import React from "react";
import { MessageCircle } from "lucide-react";
import { getWhatsAppLink } from "../lib/whatsapp";

const WhatsAppFloat = () => {
  return (
    <a href={getWhatsAppLink()} target="_blank" rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white pl-4 pr-5 py-3 rounded-full shadow-2xl shadow-green-500/40 transition-all hover:scale-105"
      aria-label="Chat on WhatsApp">
      <MessageCircle size={22} />
      <span className="font-semibold text-sm hidden sm:block">Chat on WhatsApp</span>
    </a>
  );
};

export default WhatsAppFloat;
